<script>
  import { onMount } from 'svelte';
  import { format } from 'svelte-i18n';

  import BillingForm from '@client/components/domain-card/modals/billing/billing-form.svelte';
  import { getNotificationsContext } from '@client/components/notifications';
  import { Spinner } from '@client/components/spinner';

  import { DomainsService } from '@client/services/domains';

  import { appStore } from '@client/stores/app';
  import { userStore } from '@client/stores/user';

  const { addNotification } = getNotificationsContext();

  export let nextDisabled = true;
  export let onExecute = null;
  export let onRollback = null;
  export let step = { data: {} };

  const MAXIO_DEFAULT_BILLING_ID = 9876;

  let loading = true;
  let error = '';

  let config = {
    domainname: '',
    billingid: MAXIO_DEFAULT_BILLING_ID,
    ybillingid: '',
    authcode: ''
  };

  const onKeyUp = () => {
    error = '';
  };

  const executeUpdateBillingId = async () => {
    error = '';

    $appStore.loading = true;

    const response = await DomainsService.updateBillingId(config);

    $appStore.loading = false;

    if (response.status >= 400) {
      error = $format('label.FAILURE.BILLING_ID_UPDATE', {
        values: { message: response.message }
      });

      throw new Error(response.message);
    }

    addNotification({
      text: $format('label.SUCCESS.BILLING_ID_UPDATE'),
      type: 'success',
      autohide: 2500,
      position: 'top-right'
    });

    step.data = {
      id: config.domainname,
      updates: {
        billing_customer_id: { name: 'Billing ID (Maxio)', value: config.billingid },
        billing_id: { name: 'Billing ID (Younium)', value: config.ybillingid }
      }
    };

    return response;
  };

  onMount(async () => {
    loading = true;

    try {
      const domainname = $userStore.domain;
      const { data } = await DomainsService.getAll({ screen: 'staff', perPage: 10000 });
      const domain = data.find((d) => d.domainname === domainname);

      config = {
        domainname,
        billingid: domain?.domainsettings?.billing_customer_id || MAXIO_DEFAULT_BILLING_ID,
        ybillingid: domain?.domainsettings?.billing_id || '',
        authcode: ''
      };
    } finally {
      loading = false;
    }

    if (onExecute) {
      onExecute(executeUpdateBillingId);
    }

    if (onRollback) {
      onRollback(null);
    }
  });

  $: nextDisabled = !config.domainname || !config.billingid || !config.ybillingid || !config.authcode;
</script>

{#if loading}
  <div class="loading">
    <Spinner show inline />
  </div>
{:else}
  <BillingForm bind:config {error} updating={$appStore.loading} {onKeyUp} />
{/if}

<style lang="scss">
  .loading {
    display: flex;
    justify-content: center;
    padding: var(--padding-xlarge);
  }
</style>
